// English translations
const en = {
  // Navigation
  nav: {
    guides: 'Information Hub',
    services: 'Service Connect',
    faq: 'FAQ',
    contact: 'Contact',
    about: 'About Us',
    help: 'Get Help',
    adminLogin: 'Admin Login',
  },
  
  // Landing Page
  landing: {
    badge: "Bangladesh's First Land Information Platform",
    heroTitle1: 'All Land Problems',
    heroTitle2: 'In One Place',
    heroSubtitle: 'From Namjari, Khatian, Dolil to verified lawyers and agents - all land-related information and services are now at your fingertips.',
    ctaStart: 'Get Started',
    ctaLearnMore: 'Learn More',
    emailPlaceholder: 'Enter your email',
    subscribe: 'Subscribe',
    whyChoose: 'Why Choose',
    whyChooseUs: '?',
    whyChooseDesc: 'We are committed to providing simple solutions to all land-related problems',
    popularGuides: 'Popular Guides',
    popularGuidesDesc: 'Most read information guides',
    viewAll: 'View All',
    readMore: 'Read More',
    haveProblem: 'Having land problems?',
    connectProviders: 'Connect with our verified service providers',
    findProviders: 'Find Providers',
  },
  
  // Features
  features: {
    completeInfo: 'Complete Information',
    completeInfoDesc: 'All land-related information including Namjari, Khatian, Registration in one place.',
    verifiedProviders: 'Verified Providers',
    verifiedProvidersDesc: 'Direct contact with experienced lawyers, agents and document assistants.',
    trustedPlatform: 'Trusted Platform',
    trustedPlatformDesc: 'Committed to ensuring accurate information and reliable services.',
  },
  
  // Stats
  stats: {
    guides: 'Info Guides',
    providers: 'Verified Providers',
    users: 'Satisfied Users',
  },
  
  // Categories
  categories: {
    all: 'All',
    documentation: 'Documentation',
    legal: 'Legal',
    fees: 'Fees & Costs',
    lawyer: 'Lawyer',
    agent: 'Agent',
    documentAssistant: 'Document Assistant',
  },
  
  // Information Hub
  hub: {
    title: 'Information Hub',
    subtitle: 'All important land-related information, processes and guidelines in one place.',
    searchPlaceholder: 'Search guides...',
    noResults: 'No guides found',
    tryAnother: 'Try another keyword',
  },
  
  // Guide Detail
  guide: {
    backToHub: 'Back to Information Hub',
    steps: 'Steps',
    tips: 'Important Tips',
    warning: 'Warning',
    downloadPdf: 'Download PDF',
    needHelp: 'Need Help?',
    helpDesc: 'Our verified service providers are ready to help you',
    notFound: 'Guide not found',
  },
  
  // Services
  services: {
    title: 'Service Connect',
    subtitle: 'Connect directly with verified lawyers, agents and document assistants.',
    searchPlaceholder: 'Search by name or location...',
    noResults: 'No service providers found',
    details: 'Details',
    verified: 'Verified',
    unverified: 'Unverified',
    feeRange: 'Fee',
    backToList: 'Back to Services',
    whatsappMessage: 'Message on WhatsApp',
    areYouProvider: 'Are you a service provider?',
    joinPlatform: 'Join Bhumi platform and reach thousands of customers',
    apply: 'Apply Now',
  },
  
  // Contact
  contact: {
    title: 'Contact Us',
    subtitle: 'Contact us for any land-related questions or problems. We are ready to help.',
    sendMessage: 'Send Message',
    contactInfo: 'Contact Information',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    address: 'Address',
    officeHours: 'Office Hours',
    sending: 'Sending...',
    send: 'Send Message',
  },
  
  // FAQ
  faq: {
    title: 'FAQ',
    subtitle: 'Get answers to common land-related questions and misconceptions',
    stillHaveQuestions: 'Still have questions?',
    contactUs: 'Contact us or talk to a verified service provider',
  },
  
  // About
  about: {
    title: 'Our',
    story: 'Story',
    mission: 'Our Mission',
    values: 'Our Values',
    valuesDesc: 'The principles that guide us',
    whatWeOffer: 'What We Offer',
    joinUs: 'Join Us',
    joinUsDesc: 'We are with you for any land-related problems',
  },
  
  // Privacy
  privacy: {
    title: 'Privacy Policy & Terms',
    lastUpdated: 'Last Updated',
    importantNotice: 'Important Notice',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    haveQuestions: 'Have Questions?',
  },
  
  // Ratings
  ratings: {
    title: 'Reviews & Ratings',
    writeReview: 'Write Review',
    noReviews: 'No reviews yet',
    beFirst: 'Be the first to review',
    rating: 'Rating',
    review: 'Review',
    submit: 'Submit',
    reviewerName: 'Your Name',
  },
  
  // Footer
  footer: {
    disclaimer: 'does not provide any land buying-selling or legal guarantees. We are an information and connection platform.',
    important: 'Important',
    info: 'Information',
    service: 'Service',
    organization: 'Organization',
    rights: 'All rights reserved.',
  },
  
  // Admin
  admin: {
    dashboard: 'Dashboard',
    guides: 'Guides',
    services: 'Services',
    leads: 'Leads',
    settings: 'Settings',
    users: 'Users',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    password: 'Password',
    save: 'Save',
    saving: 'Saving...',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    new: 'New',
    total: 'Total',
  },
  
  // Common
  common: {
    loading: 'Loading...',
    error: 'Something went wrong',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    more: 'More',
    less: 'Less',
  },
  
  // Install Prompt
  install: {
    title: 'Install App',
    description: 'Add to home screen for quick access',
    button: 'Install',
    iosTitle: 'Install on iOS',
    iosStep1: 'Tap the Share button below',
    iosStep2: 'Select "Add to Home Screen"',
    iosStep3: 'Tap "Add"',
    understood: 'Got it',
  },
};

export default en;
